import { Outlet, createFileRoute } from "@tanstack/react-router";

// Pathless-ish layout for the /bn section. We keep the global Header/Footer
// (from __root) so the brand stays consistent, but inject a Bangla webfont
// stack and right-to-content language wrapper for every /bn/* page.
export const Route = createFileRoute("/bn")({
  head: () => ({
    links: [
      {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/css2?family=Hind+Siliguri:wght@400;500;600;700&family=Noto+Serif+Bengali:wght@500;700&display=swap",
      },
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" },
    ],
  }),
  component: () => (
    <div
      lang="bn"
      style={{
        fontFamily:
          "'Hind Siliguri', 'Noto Serif Bengali', system-ui, -apple-system, sans-serif",
      }}
    >
      <Outlet />
    </div>
  ),
});
